import type { ReactNode } from 'react';

/** Standard list/management page header (skill §1): H1 + subtitle, CTA pinned top-right. */
export function PageHeader({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle: string;
  action?: ReactNode;
}) {
  return (
    // Stacked below 640px. Side by side, a two-button action group squeezed the
    // title into three words a line — "Visibility" over a subtitle broken across
    // four — while the buttons kept their width and the page read as broken.
    <div className="mb-6 flex flex-col items-start gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold text-gray-900">{title}</h1>
        <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
      </div>
      {action && <div className="w-full flex-shrink-0 sm:mt-1 sm:w-auto">{action}</div>}
    </div>
  );
}
